// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tsqw","questions":"styles_questions__1i_eV","footer":"styles_footer__2JqtI"};